import { createSelector } from 'reselect';

export const selectCateringOptionsSlice = state => state.cateringOptions;

export const selectCateringOptions = createSelector(
  selectCateringOptionsSlice,
  slice => slice.cateringOptions
);
export const selectActiveCateringOption = createSelector(
  selectCateringOptionsSlice,
  slice => slice.activeCateringOption
);
export const selectActiveCateringOptionPeriods = createSelector(
  selectCateringOptionsSlice,
  slice => slice.activeCateringOptionPeriods
);
export const cateringOptionCreating = createSelector(
  selectCateringOptionsSlice,
  slice => slice.isCreating
);
export const cateringOptionsMeta = createSelector(
  selectCateringOptionsSlice,
  slice => slice.meta
);
export const cateringOptionsFilters = createSelector(
  selectCateringOptionsSlice,
  slice => slice.filters
);
export const cateringOptionsEvent = createSelector(
  selectCateringOptionsSlice,
  slice => slice.eventId
);
